import "./FxeQuizComponent.scss";
import {IOnInit} from "angular";
import {ArrayUtil} from "../../../js/util/ArrayUtil";
import {StringKeyed} from "../../../types/GenericTypes";
import {QuestionResult} from "../FxeQuizQuestions";
import {ComponentCallback} from "../../../types/AngularJS";

export const FxeQuiz = "tfFxeQuiz";

export function fxeQuiz() {
    return {
        templateUrl: "app/quiz/fxe/quiz/FxeQuizComponent.html",
        bindings: {
            onComplete: "&"
        },
        controllerAs: "ctrl",
        controller: FxeQuizComponentController
    };
}

export class FxeQuizComponentController implements IOnInit {

    public onComplete: ComponentCallback;

    public questionOrder: Array<number>;
    public results: Array<QuestionResult> = [];
    public answers: StringKeyed<Array<string>> = {};

    public $onInit(): void {
        this.questionOrder = ArrayUtil.shuffle(ArrayUtil.range(12));
    }

    public answered(result: QuestionResult) {
        this.answers[result.question.name] = result.answer;
        this.updateResults(result);
    }

    private updateResults(result: QuestionResult) {
        const index = this.results.findIndex(res => res.question.name === result.question.name);
        if (index > -1) {
            this.results.splice(index, 1, result);
        } else {
            this.results.push(result);
        }
    }

    public quizComplete() {
        this.onComplete({ results: this.results });
    }
}
